export default __webpack_public_path__ + "static/media/logo.a43bc2ff.png";